import { AddLogBookMasterSetup } from 'src/pages/Setup/LogBookMasterSetup/AddLogBookMasterSetup';
import { EditLogBookMasterSetup } from 'src/pages/Setup/LogBookMasterSetup/EditLogBookMasterSetup';
import { LogBookMasterSetup } from 'src/pages/Setup/LogBookMasterSetup/Index';

export const logBookMasterSetupRoutes = [
  { path: '/log/Book/master/Setup', component: LogBookMasterSetup },
  { path: '/log/Book/master/Setup/Add', component: AddLogBookMasterSetup },
  { path: '/log/Book/master/Setup/:id', component: EditLogBookMasterSetup },
];
